import { ContentPagesEffects } from './content-pages.effect';
import { EventsEffects } from './events.effect';
import { NewsEffects } from './news.effect';

export const effects = [ContentPagesEffects, NewsEffects, EventsEffects];
export * from './content-pages.effect';
export * from './news.effect';
export * from './events.effect';
